import React from 'react';

// Fixed palette — cycles deterministically based on label string hash
const PALETTE = [
  { background: 'rgba(59,130,246,0.12)',  color: '#60a5fa', border: '1px solid rgba(59,130,246,0.25)' },
  { background: 'rgba(139,92,246,0.12)',  color: '#a78bfa', border: '1px solid rgba(139,92,246,0.25)' },
  { background: 'rgba(249,115,22,0.12)',  color: '#fb923c', border: '1px solid rgba(249,115,22,0.25)' },
  { background: 'rgba(16,185,129,0.12)',  color: '#34d399', border: '1px solid rgba(16,185,129,0.25)' },
  { background: 'rgba(236,72,153,0.12)',  color: '#f472b6', border: '1px solid rgba(236,72,153,0.25)' },
  { background: 'rgba(234,179,8,0.12)',   color: '#fbbf24', border: '1px solid rgba(234,179,8,0.25)'  },
  { background: 'rgba(20,184,166,0.12)',  color: '#2dd4bf', border: '1px solid rgba(20,184,166,0.25)' },
];

function hashIndex(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = str.charCodeAt(i) + ((h << 5) - h);
  }
  return Math.abs(h) % PALETTE.length;
}

// `label` is the category (or any string) to display.
// Colors are assigned deterministically so the same category always gets the same color.
export default function ModuleBadge({ module: label }) {
  const style = label ? PALETTE[hashIndex(label)] : PALETTE[0];
  return (
    <span
      className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-semibold tracking-wide"
      style={style}
    >
      {label || '—'}
    </span>
  );
}
